var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "changeForgottenPassword" } },
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "change-password_slim",
                  attrs: { cols: "12", sm: "4", md: "4" }
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "change_password_card",
                      attrs: { elevation: "10" }
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "change-password" },
                        [
                          !!_vm.messageOk
                            ? _c("v-alert", { attrs: { type: "success" } }, [
                                _vm._v(" " + _vm._s(_vm.messageOk))
                              ])
                            : _vm._e(),
                          !!_vm.message
                            ? _c("v-alert", { attrs: { type: "error" } }, [
                                _vm._v(" " + _vm._s(_vm.message))
                              ])
                            : _vm._e(),
                          !_vm.showForm && _vm.loadingCheckToken
                            ? _c("div", [
                                _c("h2", [_vm._v("Prebieha kontrola tokenu!")])
                              ])
                            : _vm._e(),
                          _vm.showForm
                            ? _c(
                                "v-form",
                                {
                                  ref: "cpform",
                                  attrs: {
                                    id: "change-password-form",
                                    autocomplete: "off"
                                  },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      _vm.submitchange - _vm.password
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "8",
                                            md: "8"
                                          }
                                        },
                                        [
                                          _c(
                                            "h1",
                                            {
                                              staticClass:
                                                "change-password_prihlasenie"
                                            },
                                            [_vm._v("Zmeniť heslo")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                        "no-gutters": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "8",
                                            md: "8"
                                          }
                                        },
                                        [
                                          _c(
                                            "form-component",
                                            { attrs: { title: "" } },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "dynamic-input-control",
                                                attrs: {
                                                  type: "text",
                                                  label: "SMS PIN",
                                                  outlined: ""
                                                },
                                                model: {
                                                  value: _vm.pin,
                                                  callback: function($$v) {
                                                    _vm.pin = $$v
                                                  },
                                                  expression: "pin"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                        "no-gutters": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "8",
                                            md: "8"
                                          }
                                        },
                                        [
                                          _c(
                                            "form-component",
                                            { attrs: { title: "" } },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "dynamic-input-control",
                                                attrs: {
                                                  "append-icon": _vm.showPass_new1
                                                    ? "mdi-eye"
                                                    : "mdi-eye-off",
                                                  rules: [
                                                    _vm.rules.password_new1
                                                  ],
                                                  type: _vm.showPass_new1
                                                    ? "text"
                                                    : "password",
                                                  label: "Nové heslo",
                                                  outlined: ""
                                                },
                                                on: {
                                                  "click:append": function(
                                                    $event
                                                  ) {
                                                    _vm.showPass_new1 = !_vm.showPass_new1
                                                  }
                                                },
                                                model: {
                                                  value: _vm.password_new1,
                                                  callback: function($$v) {
                                                    _vm.password_new1 = $$v
                                                  },
                                                  expression: "password_new1"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                        "no-gutters": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "8",
                                            md: "8"
                                          }
                                        },
                                        [
                                          _c(
                                            "form-component",
                                            { attrs: { title: "" } },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "dynamic-input-control",
                                                attrs: {
                                                  "append-icon": _vm.showPass_new2
                                                    ? "mdi-eye"
                                                    : "mdi-eye-off",
                                                  rules: [
                                                    _vm.rules.password_new2
                                                  ],
                                                  type: _vm.showPass_new2
                                                    ? "text"
                                                    : "password",
                                                  label: "Zopakujte heslo",
                                                  outlined: ""
                                                },
                                                on: {
                                                  "click:append": function(
                                                    $event
                                                  ) {
                                                    _vm.showPass_new2 = !_vm.showPass_new2
                                                  }
                                                },
                                                model: {
                                                  value: _vm.password_new2,
                                                  callback: function($$v) {
                                                    _vm.password_new2 = $$v
                                                  },
                                                  expression: "password_new2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _vm.showForm
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "btn-primary mt-20px right",
                                          attrs: { loading: _vm.loading },
                                          on: {
                                            click: function($event) {
                                              return _vm.changePassword()
                                            }
                                          }
                                        },
                                        [_vm._v("Zmeniť heslo")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "btn-secondary mt-20px mr-20px right",
                                          attrs: { to: "/" },
                                          on: {
                                            click: _vm.changePasswordCancel
                                          }
                                        },
                                        [_vm._v("Zrušiť")]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "btn-secondary mt-20px mr-20px right",
                                          attrs: { to: "/" },
                                          on: {
                                            click: _vm.changePasswordCancel
                                          }
                                        },
                                        [_vm._v("Zatvoriť")]
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }